/**
 *
 *
 */

import { useEffect, useState } from 'react';
import { Content, Title, ModalLayout } from 'components';
import { Empty, Button, Descriptions, Divider, Form, Input, Flex } from 'antd';
import MessageAlert from 'utils';
import { FileSearchOutlined, MinusOutlined } from '@ant-design/icons';
import {
  useProductDetailInformationDispatch,
  useProductDetailInformationState,
} from '../context/ProductDetailInformationProvider';

const initialInputData = {
  key: '',
  value: '',
  defaultKey: null,
};

/**----------------------------------------
 * [Component] 총관리자: 상품등록 > 상세정보
 * ----------------------------------------
 */
const ProductDetailInformation2 = ({ defaultData, editMode, onChange }) => {
  // console.log('defaultData22: ', defaultData);

  /* ===== Init ===== */
  const dispatch = useProductDetailInformationDispatch();

  /* ===== STATE ===== */
  const [modal, setModal] = useState(null);
  const [data, setData] = useState(
    defaultData && defaultData.product_detail
      ? Object.entries(defaultData.product_detail)
      : []
  );
  const [inputData, setInputData] = useState(initialInputData);
  /* ===== FUNCTIONS ===== */

  /**
   * 저장함수
   * --
   */
  const handleSave = () => {
    const { key, value } = inputData;
    // 빈값체크
    if (!key || !value) {
      return MessageAlert.warning('모든 항목을 입력해주세요');
    }

    const splitKey = modal.split('-');

    handleDataEntry(
      splitKey.length > 1 ? 'CHILDREN-UPDATE' : 'CHILDREN-ADD',
      Number(splitKey[0]),
      { [key]: value },
      Number(splitKey[1])
    );
    setModal(null);
    setInputData(initialInputData);
  };

  const handleDataEntry = (type, index, value, subIndex) => {
    switch (type) {
      case 'ADD':
        setData((prev) => [...prev, ['', []]]);
        break;
      case 'REMOVE':
        setData((prev) => [...prev.slice(0, index), ...prev.slice(index + 1)]);
        break;
      case 'TITLE':
        setData((prev) => [
          ...prev.slice(0, index),
          [value, prev[index][1]],
          ...prev.slice(index + 1),
        ]);
        break;
      case 'CHILDREN-ADD':
        setData((prev) => [
          ...prev.slice(0, index),
          [prev[index][0], [...prev[index][1], value]],
          ...prev.slice(index + 1),
        ]);
        break;
      case 'CHILDREN-UPDATE':
        setData((prev) => [
          ...prev.slice(0, index),
          [
            prev[index][0],
            [
              ...prev[index][1].slice(0, subIndex),
              value,
              ...prev[index][1].slice(subIndex + 1),
            ],
          ],
          ...prev.slice(index + 1),
        ]);
        break;
      case 'CHILDREN-REMOVE':
        setData((prev) => [
          ...prev.slice(0, index),
          [
            prev[index][0],
            [
              ...prev[index][1].slice(0, subIndex),
              ...prev[index][1].slice(subIndex + 1),
            ],
          ],
          ...prev.slice(index + 1),
        ]);
        break;
      default:
        break;
    }
  };

  /* ===== HOOKS ===== */
  useEffect(() => {
    onChange(data);
    dispatch({ type: 'detail_info', value: data });
  }, [data]);

  useEffect(() => {
    if (defaultData && defaultData?.product_detail) {
      const newDetail = Object.entries(defaultData?.product_detail).map(
        ([key, value]) => {
          return [
            key,
            Object.entries(value).map(([subKey, subValue]) => ({
              [subKey]: subValue,
            })),
          ];
        }
      );
      setData(newDetail);
    }
  }, [defaultData]);

  /* ===== RENDER ===== */

  return (
    <Content
      maxWidth={'100%'}
      padding={20}
      borderRadius={4}
      style={{ marginBottom: 25 }}
      className="boxShadow"
    >
      <div
        style={{
          width: '100%',
          display: 'flex',
          justifyContent: 'space-between',
        }}
      >
        <Title size={5} align="left" style={{ marginBottom: 10 }}>
          <FileSearchOutlined /> 상세 정보
        </Title>
        {editMode && (
          <Button type={'primary'} onClick={() => handleDataEntry('ADD')}>
            상세 정보 추가
          </Button>
        )}
      </div>
      <br />
      {!data?.length ? (
        <div
          style={{
            width: '100%',
            height: '250px',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
          }}
        >
          <Empty />
        </div>
      ) : (
        data?.map((item, index) => (
          <div
            key={`product_detail_data_${index}`}
            style={{ marginBottom: '15px' }}
          >
            <Flex gap={24}>
              <Flex flex={1}>
                <Input
                  value={item[0]}
                  placeholder="타이틀을 입력해주세요."
                  onChange={(e) =>
                    handleDataEntry('TITLE', index, e.target.value)
                  }
                />
              </Flex>

              <Flex gap={4}>
                <Button onClick={() => setModal(`${index}`)}>내용 추가</Button>
                <Button
                  danger
                  onClick={() => handleDataEntry('REMOVE', index)}
                  icon={<MinusOutlined />}
                />
              </Flex>
            </Flex>

            {item[1].length ? (
              <div style={{ marginTop: 10 }}>
                <Descriptions
                  bordered
                  size="middle"
                  labelStyle={{
                    width: '200px',
                    backgroundColor: '#F4F4F5',
                    color: 'black',
                    fontSize: '13px',
                  }}
                  items={item[1].map((subItem, subIndex) => ({
                    key: `${subIndex}`,
                    label: Object.keys(subItem),
                    children: (
                      <Flex gap={24} align="stretch">
                        <Flex flex={1}>
                          <pre
                            style={{
                              whiteSpace: 'pre-wrap',
                              wordWrap: 'break-word',
                              overflowWrap: 'break-word',
                              wordBreak: 'break-all',
                            }}
                          >
                            {Object.values(subItem)}
                          </pre>
                        </Flex>

                        <Flex gap={4}>
                          <Button
                            onClick={() => {
                              setInputData({
                                key: Object.keys(subItem),
                                value: Object.values(subItem),
                              });
                              setModal(`${index}-${subIndex}`);
                            }}
                          >
                            수정
                          </Button>
                          <Button
                            danger
                            onClick={() =>
                              handleDataEntry(
                                'CHILDREN-REMOVE',
                                index,
                                null,
                                subIndex
                              )
                            }
                          >
                            삭제
                          </Button>
                        </Flex>
                      </Flex>
                    ),
                    span: 'filled',
                  }))}
                />
              </div>
            ) : null}
          </div>
        ))
      )}

      {/* === 생성모달 === */}
      {editMode && (
        <ModalLayout
          type={'modal'}
          open={typeof modal === 'string'}
          onCancel={() => setModal(null)}
          centered
          closable
          title={'상세 정보 설정'}
          width={630}
          footer={
            <Button type="primary" onClick={handleSave}>
              저장
            </Button>
          }
        >
          <Divider style={{ marginTop: '12px 0' }} />
          <Form layout="vertical">
            <Form.Item label="상세정보 제목">
              <Input
                value={inputData.key}
                placeholder="내용을 입력해주세요"
                //disabled={state.prevKey ? true : false}
                onChange={(e) =>
                  setInputData({ ...inputData, key: e.target.value })
                }
              />
            </Form.Item>
            <Form.Item label="상세정보 내용">
              <Input.TextArea
                value={inputData.value}
                style={{ height: 200, resize: 'none' }}
                placeholder="내용을 입력해주세요"
                onChange={(e) =>
                  setInputData({ ...inputData, value: e.target.value })
                }
              />
            </Form.Item>
          </Form>
        </ModalLayout>
      )}
    </Content>
  );
};

ProductDetailInformation2.defaultProps = {
  onChange: () => {},
  editMode: false,
  defaultData: null,
};
export default ProductDetailInformation2;
